import isEqual from 'lodash/fp/isEqual';
import { memo, FC } from 'react';

import Wrapper from './Wrapper';
import { useDrawChart } from './hooks';
import { HorizontalChartProps } from './types';

export * from './types'

const ChartBar: FC<HorizontalChartProps> = props => {
  const chartRef = useDrawChart(props);

  return <Wrapper ref={chartRef} />;
};

const MemorizedChartBar = memo(ChartBar, isEqual);

export default MemorizedChartBar;
